import { Spinner } from "react-bootstrap";
import styles from "./button.module.scss";

const Button = ({ text, icon, disabled, isloading, formSended, ...rest }) => {
  return (
    <>
      <button
        disabled={disabled}
        className={`${styles.buttonWrapper} ${
          formSended ? styles.formSended : ""
        }`}
        type="button"
        {...rest}
      >
        <span>
          {isloading ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            text
          )}
        </span>
        {icon}
      </button>
    </>
  );
};

export default Button;
